import { formatDuration, type ExperienceTier, type PieceGroup, type ShiftPlanning } from '@reditelji/shared';
import type { ChipTone } from './derive';

/** The short word a candidate row wears for how experienced they are. */
export const TIER_WORD: Record<ExperienceTier, string> = {
  'zelo-izkušen': 'zelo izkušen',
  izkušen: 'izkušen',
  neznano: 'neocenjen',
  neizkušen: 'neizkušen',
};

/** How each candidate group is headed, and the dot beside it. */
export const GROUP_HEAD: Record<PieceGroup, { label: string; dot: string }> = {
  rec: { label: 'Priporočeni', dot: 'oklch(0.6 0.1 155)' },
  warn: { label: 'Mogoči, z opozorilom', dot: 'oklch(0.68 0.11 75)' },
  flag: { label: 'Proti prijavnici ali dnevni meji', dot: 'oklch(0.58 0.15 25)' },
  busy: { label: 'Takrat zasedeni', dot: 'oklch(0.64 0.012 90)' },
};

export function Chips({ chips, max }: { chips: { tone: ChipTone; text: string }[]; max?: number }) {
  const shown = max === undefined ? chips : chips.slice(0, max);
  if (shown.length === 0) return null;
  return (
    <span className="tl-cand-chips">
      {shown.map((c) => (
        <span key={`${c.tone}:${c.text}`} className={`tl-cand-chip tl-cand-chip--${c.tone}`}>
          {c.text}
        </span>
      ))}
    </span>
  );
}

/** "3 h → 7 h 30 min", the second figure coloured once it passes a daily ceiling. */
export function Load({
  beforeMin,
  afterMin,
  planning,
}: {
  beforeMin: number;
  afterMin: number;
  planning: ShiftPlanning;
}) {
  const soft = Math.min(planning.softDailyMin, planning.maxDailyMin);
  const tone = afterMin > planning.maxDailyMin ? ' tl-cand-load--over' : afterMin > soft ? ' tl-cand-load--long' : '';
  return (
    <span className="tl-cand-load">
      {beforeMin > 0 ? formatDuration(beforeMin) : '0 h'} → <b className={tone}>{formatDuration(afterMin)}</b>
    </span>
  );
}
